import { LoadingButton } from "@mui/lab";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { FirmWithLenses } from "generated/graphql";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import RequestStatus from "redux/slices/RequestStatus";
import { P } from "theme/typography";
import { useState } from "react";
import { deleteFirm } from "redux/slices/client";

interface FirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  firmToDelete: FirmWithLenses | undefined;
}

const FirmDeleteDialog = (props: FirmDeleteDialogProps) => {
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.IDLE);
  const snackpatch = useAppDispatchWithSnackbar();

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      maxWidth="md">
      <DialogContent>
        <P variant="h5">Delete Firm</P>
        <P
          sx={{
            mt: 1,
          }}>
          You are about to delete the firm &quot;{props.firmToDelete?.name}&quot;. This action cannot be undone.
        </P>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose();
          }}>
          Cancel
        </Button>
        <LoadingButton
          loading={status === RequestStatus.PENDING}
          onClick={() => {
            if (props.firmToDelete)
              void snackpatch(
                deleteFirm({
                  firmId: props.firmToDelete.id,
                }),
                {
                  successMessage: "Firm deleted successfully",
                  errorMessage: "Unable to delete firm",
                }
              ).then(() => {
                setStatus(RequestStatus.SUCCEEDED);
                props.onClose();
              });
          }}
          variant="contained">
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default FirmDeleteDialog;
